import React from 'react';
import '../styles/HangmanDisplay.css';

const HangmanDisplay = ({ wrongGuesses }) => {
  return (
    <div className="hangman-display">
      <svg height="200" width="200" className="hangman-svg">
        {/* Base */}
        <line x1="40" y1="180" x2="160" y2="180" className="hangman-line" />
        
        {/* Vertical pole */}
        <line x1="60" y1="20" x2="60" y2="180" className="hangman-line" />
        
        {/* Horizontal beam */}
        <line x1="60" y1="20" x2="140" y2="20" className="hangman-line" />
        
        {/* Rope */}
        <line x1="140" y1="20" x2="140" y2="40" className="hangman-line" />
        
        {/* Head */}
        {wrongGuesses >= 1 && (
          <circle cx="140" cy="60" r="20" className="hangman-part" />
        )}
        
        {/* Body */}
        {wrongGuesses >= 2 && (
          <line x1="140" y1="80" x2="140" y2="120" className="hangman-part" />
        )}
        
        {/* Left arm */}
        {wrongGuesses >= 3 && (
          <line x1="140" y1="90" x2="120" y2="100" className="hangman-part" />
        )}
        
        {/* Right arm */}
        {wrongGuesses >= 4 && (
          <line x1="140" y1="90" x2="160" y2="100" className="hangman-part" />
        )}
        
        {/* Left leg */}
        {wrongGuesses >= 5 && (
          <line x1="140" y1="120" x2="120" y2="150" className="hangman-part" />
        )}
        
        {/* Right leg */}
        {wrongGuesses >= 6 && (
          <line x1="140" y1="120" x2="160" y2="150" className="hangman-part" />
        )}
        
        {/* Face (only show when game is lost) */}
        {wrongGuesses >= 6 && (
          <>
            {/* Left eye */}
            <line x1="135" y1="55" x2="145" y2="65" className="hangman-face" />
            <line x1="145" y1="55" x2="135" y2="65" className="hangman-face" />
            
            {/* Right eye */}
            <line x1="135" y1="55" x2="145" y2="65" className="hangman-face" transform="translate(10, 0)" />
            <line x1="145" y1="55" x2="135" y2="65" className="hangman-face" transform="translate(10, 0)" />
            
            {/* Sad mouth */}
            <path d="M130,70 Q140,60 150,70" className="hangman-face" fill="none" />
          </>
        )}
      </svg>
    </div>
  );
};

export default HangmanDisplay; 